import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { DecorativeBlobContainer, SmallDecorativeBlob } from './Blob.styles';
export const DecorativeBlobs = ({
  colorTheme
}) => {
  const {
    innerBlobColor,
    smallDecorativeBlobColor
  } = colorTheme;
  return /*#__PURE__*/_jsxs(DecorativeBlobContainer, {
    children: [/*#__PURE__*/_jsx(SmallDecorativeBlob, {
      style: {
        background: smallDecorativeBlobColor
      }
    }), /*#__PURE__*/_jsx("div", {
      style: {
        background: innerBlobColor
      }
    })]
  });
};